import { Form } from '@radix-ui/react-form';
import { Button, TextField } from '@radix-ui/themes';

export default function LoginForm({ formData, error, handleChange, handleSubmit }) {
    return (
        <>
            <header className="redesign-page-header" style={{ marginBottom: 24 }}>
                <h1 className="redesign-page-title">管理员登录</h1>
            </header>
            <Form onSubmit={handleSubmit}>
                <div className="redesign-form-field">
                    <label className="redesign-form-label" htmlFor="username">账号 *</label>
                    <TextField.Root name="username" id="username" value={formData.username} onChange={handleChange} />
                    {(error.code == 'login_username_invalid' || error.code == 'login_username_password_invalid') && (
                        <span style={{ color: '#c62828', fontSize: 13 }}>{error.message}</span>
                    )}
                </div>

                <div className="redesign-form-field">
                    <label className="redesign-form-label" htmlFor="password">密码 *</label>
                    <TextField.Root type="password" name="password" placeholder="密码" id="password" value={formData.password} onChange={handleChange} />
                    {error.code == 'login_password_invalid' && (
                        <span style={{ color: '#c62828', fontSize: 13 }}>{error.message}</span>
                    )}
                </div>

                <Button type="submit" className="redesign-btn-primary" style={{ width: '100%', marginTop: 8 }}>
                    登录
                </Button>
            </Form>
        </>
    )
}
